import Vue from 'vue';
import Vuetify from 'vuetify';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import apolloProvider from './graphql/apolloClient';
import router from './router';
import EventBus from './eventBus';
import VueSession from 'vue-session';

Vue.config.productionTip = false;

Vue.prototype.$bus = EventBus;

Vue.use(Vuetify);
Vue.use(VueSession);

new Vue({
  vuetify,
  axios,
  VueAxios,
  apolloProvider,
  router,
  render: (h) => h(App),
}).$mount('#app');
